import { Box, Button, Input, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { portalMessages as m } from "./messages";

export interface Period {
  start: string;
  end: string;
}

export const PARTIAL_KINDS = ["BREASTFEEDING", "PRENATAL"];

/** The periods of each working day when a dispensa is taken. */
export const DispensationPeriods = ({
  periods,
  onChange,
  showHint = false,
}: {
  periods: Period[];
  onChange: (periods: Period[]) => void;
  showHint?: boolean;
}) => {
  const intl = useIntl();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Text size={2} fontWeight="bold">
        {intl.formatMessage(m.dispensationPeriods)}
      </Text>
      {periods.map((period, index) => (
        <Box key={index} display="flex" gap={2} alignItems="center">
          <Input
            size="small"
            type="time"
            label={intl.formatMessage(m.start)}
            value={period.start}
            onChange={event =>
              onChange(
                periods.map((p, i) => (i === index ? { ...p, start: event.target.value } : p)),
              )
            }
          />
          <Input
            size="small"
            type="time"
            label={intl.formatMessage(m.end)}
            value={period.end}
            onChange={event =>
              onChange(periods.map((p, i) => (i === index ? { ...p, end: event.target.value } : p)))
            }
          />
          {periods.length > 1 && (
            <Button
              size="small"
              variant="tertiary"
              onClick={() => onChange(periods.filter((_, i) => i !== index))}
            >
              ×
            </Button>
          )}
        </Box>
      ))}
      {periods.length < 2 && (
        <Box>
          <Button
            size="small"
            variant="secondary"
            onClick={() => onChange([...periods, { start: "09:00", end: "10:00" }])}
          >
            {intl.formatMessage(m.addPeriod)}
          </Button>
        </Box>
      )}
      {showHint && (
        <Text size={1} color="default2">
          {intl.formatMessage(m.dispensationHint)}
        </Text>
      )}
    </Box>
  );
};
